<div class="flex justify-between items-center pl-4 mb-4">
  <h1>Inspection</h1>
  <div class="flex gap-3">
    @if (inspection.hasValue()) {
      <lib-button [cssType]="'btn-secondary'" [buttonType]="'button'" [text]="'Manage'" [size]="'small'" (click)="manage()"></lib-button>
    }
    @if (model()) {
      <lib-button [cssType]="'btn-primary'" [buttonType]="'button'" [icon]="'download'" [text]="'Download PDF'" [size]="'small'" (click)="download()"></lib-button>
    }
  </div>
</div>

@if (inspection.error() || report.error(); as error) {
  <p class="pl-4">{{ error.message }}</p>
}

@if (inspection.hasValue() && !model()) {
  @let summary = inspection.value();
  <div class="flex flex-col w-full lg:w-3/4 mx-auto">
    <p class="bold">{{ summary.businessName }}</p>
    <p><span class="bold">Policy #: </span>{{ summary.policyNumber }}</p>
    @if (summary.inspectionNumber) {
      <p><span class="bold">Inspection #: </span>{{ summary.inspectionNumber }}</p>
    }
    <p><span class="bold">Status: </span>{{ status() }}</p>
    <p><span class="bold">Ordered: </span>{{ summary.createDate | date: 'MM/dd/yyyy' }}</p>
  </div>
}

@if (model(); as report) {
  <div class="flex flex-col w-full lg:w-3/4 mx-auto">
    <div class="flex w-full">
      <div class="w-1/2">
        <p class="bold">{{ report.insuredBusinessInformation?.businessName }}</p>
        <p><span class="bold">Policy #: </span>{{ report.policyNumber }}</p>
        @if (report.inspectionNumber) {
          <p><span class="bold">Inspection #: </span>{{ report.inspectionNumber }}</p>
        }
        <p><span class="bold">Business Type: </span>{{ businessType() }}</p>
        <p><span class="bold">Contractors License Number: </span>{{ report.insuredBusinessInformation?.contractorLicenseNumber }}</p>
      </div>
      <div class="w-1/2">
        <p><span class="bold">Completed: </span>{{ report.completedDate | date: 'MM/dd/yyyy' }}</p>
        <p><span class="bold">Signed By: </span>{{ report.signedBy }}</p>
        @if (report.insuredBusinessInformation?.primaryAddress; as address) {
          <p class="bold">Primary Business Address:</p>
          <p>{{ address.streetAddress }} {{ address.suiteOrUnit }}</p>
          <p>{{ address.city }}, {{ address.state }} {{ address.zipCode }}</p>
        }
      </div>
    </div>

    @if (report.legacyPolicy) {
      <p class="mt-3">This policy was bound before the application asked for owners in the field and class percentages, so classes show payroll and the payroll total includes owners.</p>
    }

    <table class="mt-[35px] inspection-report-table">
      <thead>
        <tr>
          <th class="text-left">Operations</th>
          <th class="text-left">Application</th>
          <th class="text-left">Inspection</th>
        </tr>
      </thead>
      <tbody>
        @for (row of operations(); track row.label) {
          <tr [class.changed]="row.changed">
            <td class="bold">{{ row.label }}</td>
            <td>{{ row.application }}</td>
            <td>{{ row.inspection }}</td>
          </tr>
        }
      </tbody>
    </table>

    <table class="mt-[35px] inspection-report-table">
      <thead>
        <tr>
          <th class="text-left">Classifications</th>
          <th class="text-left">Application</th>
          <th class="text-left">Inspection</th>
        </tr>
      </thead>
      <tbody>
        @for (row of classes(); track row.label) {
          <tr [class.changed]="row.changed">
            <td class="bold">{{ row.label }}</td>
            <td>{{ row.application }}</td>
            <td>{{ row.inspection }}</td>
          </tr>
        }
      </tbody>
    </table>

    <div class="mt-[35px]">
      <p><span class="bold">Eligibility Statements Reviewed: </span>{{ report.eligibilityReviewed ? 'Yes' : 'No' }}</p>
      <ul class="list-disc pl-6">
        @for (section of report.eligibilitySections ?? []; track section) {
          <li>{{ section }}</li>
        }
      </ul>
    </div>

    @if (report.additionalDetails) {
      <div class="mt-[35px]">
        <p class="bold">Additional Details</p>
        <p class="whitespace-pre-line">{{ report.additionalDetails }}</p>
      </div>
    }
  </div>
}
